import { fetchWithAuthorization } from '../../../helpers/fetch-with-authorization';

export type ClaimTrialFn = (payload: {
    request: {
        vehicleDeviceId: string;
        useExistingOEMProfile: boolean;
        oemDriverId?: string;
    };
    accessToken: string;
}) => Promise<unknown>;

export function initClaimTrialFn({
    baseUrl,
}: {
    baseUrl: string;
}): ClaimTrialFn {
    const href = 'uso-service/v1/b2btrial/claim';
    return async ({ request, accessToken }) => {
        const url = `${baseUrl}/${href}`;
        const response = await fetchWithAuthorization({
            url,
            method: 'POST',
            accessToken,
            body: request,
        });
        if (!response.ok) return Promise.reject(await response.json());
        /**
         * TODO:
         * Figure out to refresh convergence token.
         */
        /**
         * TODO:
         * https://ghe.siriusxm.com/platform-common/api-registry/blob/main/sequence-diagrams/tesla/qr_flow.md#claiming-the-trial
         */
        return response.json();
    };
}
